<div class="tw-overflow-x-hidden tw-h-full" [nbSpinner]="!ready" nbSpinnerMessage="Capacity dashboard is being loaded">
  <ngx-zones-header
    *ngIf="ready && !singleMode"
    [zone]="currentZone"
    [zones]="zones"
    [status]="isLive"
    (selectedZone)="currentZone = $event"
    (refreshRequested)="ngOnInit()"
  ></ngx-zones-header>
  <ngx-event-info
    *ngIf="ready"
    [zones]="zones"
    [singleMode]="singleMode"
    [event]="event"
    [zone]="currentZone"
    [authenticated]="authenticated"
    (isShow)="updateCurrentView($event)"
    (selectedZone)="currentZone = $event"
  >
  </ngx-event-info>
  <ngx-capacity-card
    *ngIf="ready && !showDaily"
    [zone]="currentZone"
    [mainZone]="mainZone"
    [zones]="zones"
    [eventSlug]="event.slug"
    [workspaceSlug]="workspaceSlug"
    [authenticated]="authenticated"
    [eventId]="eventId"
    [singleMode]="singleMode"
  ></ngx-capacity-card>
  <ngx-capacity-by-daily-dates *ngIf="ready && showDaily" [zone]="currentZone" [event]="event" [workspaceSlug]="workspaceSlug"></ngx-capacity-by-daily-dates>
  <ngx-venu-capacity-footer [theme]="theme"></ngx-venu-capacity-footer>
</div>
